module.exports = __webpack_public_path__ + "img/1-vs-3-fase-groepenkast.8ce3866c.png";